import { Box, Group, Stack, createStyles } from '@mantine/core';
import type {
	MonitorCreationProposal,
	SecodaAIProposalOut,
} from '@repo/api-codegen';
import { Text } from '@repo/foundations';
import IntegrationLogo from '../../../IntegrationLogo/IntegrationLogo';
import { QueryCode } from '../../../QueryCodeBlock/QueryCode';
import { getScheduleText } from '../../utils';

const useStyles = createStyles((theme) => ({
	integrationContainer: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		borderRadius: theme.radius.sm,
		background: theme.other.getColor('surface/secondary/default'),
		width: theme.spacing.xl,
		height: theme.spacing.xl,
	},
	fieldTitle: {
		minWidth: 80,
	},
	queryCode: {
		padding: `0 !important`,
	},
}));

export function MonitorCreationRenderer({
	data,
	proposal,
}: {
	proposal: SecodaAIProposalOut;
	data: MonitorCreationProposal;
}) {
	const { classes, theme } = useStyles();
	const { name, schedule, integration_id } = data.data;

	return (
		<Stack spacing="md" p="xl">
			{/* Header */}
			<Box className={classes.integrationContainer}>
				<IntegrationLogo integrationId={integration_id} size={28} />
			</Box>
			<Text size="xxl" weight="bold">
				{name}
			</Text>

			{/* Description */}
			{data.data.description && (
				<Box mt={theme.spacing.xs} mb={theme.spacing.sm}>
					<Text size="md">{data.data.description}</Text>
				</Box>
			)}

			{/* Meta Section: Schedule only */}
			<Box>
				<Stack spacing={0}>
					<Group spacing={0} align="center" noWrap>
						<Box className={classes.fieldTitle}>
							<Text size="sm" color="text/secondary/default">
								Schedule
							</Text>
						</Box>
						<Box ml="md">
							<Text size="sm">{getScheduleText(schedule)}</Text>
						</Box>
					</Group>
				</Stack>
			</Box>

			<QueryCode
				query={data.data.sql_query}
				className={classes.queryCode}
				minHeight={180}
			/>
		</Stack>
	);
}
